import type { UserInfo } from "../types/auth";


/**
 * Basic middleware implementation to ensure that the user is authenticated
 * before accessing any protected route
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) return;

  const { login, loggedIn, user } = useOidcAuth();

  const { requireAuthAll, requireRolesAll } = useRuntimeConfig().public.authStack

  if (!requireAuthAll && !to.meta.requiresAuth) {
    return
  }

  if ((to.meta.requiresAuth || requireAuthAll) && !loggedIn.value) {
    return login();
  }

  const requiredRoles: string[] = to.meta.requiresRoles || requireRolesAll
  const userInfo: UserInfo = user.value?.userInfo as UserInfo;
  if (requiredRoles.length > 0 && !requiredRoles.every(role => userInfo.roles?.includes(role))) {
    // user does not have the required roles, redirect to forbidden page
    throw createError({
      statusCode: 403,
      statusMessage: 'Forbidden',
      message: 'You do not have the required roles to access this page.'
    })
  }
});
